import { Link } from "react-router-dom";
import { Home as HomeIcon, Phone } from "lucide-react";
import { BUSINESS } from "../config/business";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="section py-24 text-center" data-testid="not-found">
      <SEO title={`Page Not Found | ${BUSINESS.name}`} description="Page not found." path="/404" />
      <p className="font-head font-extrabold text-7xl text-volt">404</p>
      <h1 className="mt-4 font-head font-bold text-2xl text-ink">Page not found</h1>
      <p className="mt-2 text-ink/60 font-body">The page you're looking for doesn't exist. Let's get you back on track.</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link to="/" className="btn-volt"><HomeIcon className="h-4 w-4" /> Back Home</Link>
        <a href={`tel:${BUSINESS.phoneTel}`} className="btn-outline"><Phone className="h-4 w-4" /> {BUSINESS.phoneDisplay}</a>
      </div>
    </div>
  );
}
